import {
  CASELOAD_SOURCE_RULE_BASED,
  CASELOAD_SOURCE_CLEVER,
  CASELOAD_SOURCE_ONE_ROSTER,
  CASELOAD_SOURCE_CUSTOM_SCRIPT,
  CASELOAD_SOURCE_CSV,
} from 'modules/RosterAndTagManagement/constants';

const options = [
  {
    id: CASELOAD_SOURCE_CLEVER,
    name: 'Clever',
  },
  {
    id: CASELOAD_SOURCE_CSV,
    name: 'CSV',
  },
  {
    id: CASELOAD_SOURCE_CUSTOM_SCRIPT,
    name: 'Custom',
  },
  {
    id: CASELOAD_SOURCE_ONE_ROSTER,
    name: 'OneRoster',
  },
  {
    id: CASELOAD_SOURCE_RULE_BASED,
    name: 'Rule-based',
  },
];

const getCaseloadSourceFilter = () => ({
  key: 'caseloadSource',
  source: 'caseloadSource',
  filterName: 'Source',
  searchable: false,
  defaultSelection: options,
  options,
  selector: 'id',
  label: 'name',
});

export default getCaseloadSourceFilter;
